import React from 'react';
import { useNavigate } from 'react-router-dom';

interface HelpIconProps {
  section: string;
  tooltip?: string;
  className?: string;
}

const HelpIcon: React.FC<HelpIconProps> = ({ section, tooltip, className = "w-4 h-4" }) => {
  const navigate = useNavigate();

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    // Navigate to the manual with the specific section
    navigate(`/manual#manual/${section}`);
    // Also update the URL for direct linking
    window.location.hash = `#manual/${section}`;
  };

  return (
    <button
      onClick={handleClick}
      className="inline-flex items-center justify-center text-slate-400 hover:text-indigo-600 transition-colors"
      title={tooltip || "Click for help"}
      aria-label="Help"
    >
      <svg 
        xmlns="http://www.w3.org/2000/svg" 
        fill="none" 
        viewBox="0 0 24 24" 
        strokeWidth={1.5} 
        stroke="currentColor" 
        className={className}
      >
        <path 
          strokeLinecap="round" 
          strokeLinejoin="round" 
          d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9 5.25h.008v.008H12v-.008z" 
        />
      </svg>
    </button>
  );
};

export default HelpIcon;